import styled from 'styled-components';

interface Wrapper {
  homePath?: boolean;
  isBoxShadow?: boolean;
}

export const Wrapper = styled.div<Wrapper>`
  height: 72px;
  display: flex;
  align-items: center;
  background: #fff;
  width: 100%;
  ${({ isBoxShadow }) =>
    isBoxShadow &&
    `
		box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
	`};
  padding-left: ${({ homePath }) => (homePath ? '20px' : '0')};
`;

export const Title = styled.h3`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 30px;
`;
